import { price } from '@eti/utils';
import { Text } from '@etg/wings';
import { useTranslation } from '@eti/providers';
import type { ChargingCurrency } from '@eti/schema-types';
import { CartRow, Price } from './CartComponents';

export interface DisplayChargingCurrencyProps {
  totalPriceWithFees: number;
  chargingCurrency: ChargingCurrency;
}

const DisplayChargingCurrency = ({
  totalPriceWithFees,
  chargingCurrency,
}: DisplayChargingCurrencyProps) => {
  const { t } = useTranslation();

  const PriceFormatter = price.createPriceFormatter(chargingCurrency.priceFormat);

  const priceInChargeCurrency = PriceFormatter.formatPrice(
    totalPriceWithFees / chargingCurrency?.value,
  );
  return (
    <CartRow>
      <Text>{t('TravelerDetails.ChargingCurrency.Text')}</Text>
      <Price>{priceInChargeCurrency}</Price>
    </CartRow>
  );
};

export default DisplayChargingCurrency;
